import toast from "react-hot-toast";
import { apiDelete, apiGet } from "../../../components/Common/Axios";
import {
  ClassNames,
  DisplayStages,
  DisplayYears,
  Order,
  Sort,
  StageName,
  StageType,
} from "../../../lib/types";
import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  PageContainer,
  PageHeader,
  SectionCard,
  Toolbar,
} from "../../../components/Layout/PageShell";
import { Link } from "react-router-dom";
import SchoolSalesPopup from "../Main/SchoolSalesPopup";
import { DescriptionOutlined } from "@mui/icons-material";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Label } from "components/ui/label";
import { Checkbox } from "components/ui/checkbox";
import { RootState, useAppDispatch, useAppSelector } from "store";
import {
  setSalesYears,
  setSchoolYears,
  setSearchTotalStatus,
} from "store/mainSlice";
import { Switch } from "components/ui/switch";
import { School, SchoolSales } from "lib/models";
import { setMenuIndex } from "store/userSlice";
import { cn, formatKoreanDate, getMonth, getYear } from "lib/utils";
import SchoolIcon from "components/Common/school-type";
import Stage from "components/Common/stage";
import { Input } from "components/ui/input";

const SchoolSalesListView = ({
  schoolSalesList,
  setSchoolSalesList,
  isTotal,
}: {
  schoolSalesList: SchoolSales[];
  setSchoolSalesList: (schoolSalesList: SchoolSales[]) => void;
  isTotal: boolean;
}) => {
  //const [schoolSalesList, setSchoolSalesList] = useState<SchoolSales[]>([]);
  const [filteredSchoolSalesList, setFilteredSchoolSalesList] = useState<
    SchoolSales[]
  >([]);
  const [sort, setSort] = useState<Sort>("region");
  const [order, setOrder] = useState<Order>("asc");
  const [searchString, setSearchString] = useState<string>("");
  const [filterStage, setFilterStage] = useState<number[]>([]);
  const [selectedSchool, setSelectedSchool] = useState<School | undefined>(
    undefined
  );
  const [selectedSchoolSales, setSelectedSchoolSales] = useState<
    SchoolSales | undefined
  >(undefined);
  const [openSales, setOpenSales] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [selectMonth, setSelectMonth] = useState<number>(0);

  const [isShowFree, setIsShowFree] = useState<boolean>(false);

  const salesYears = useAppSelector(
    (state: RootState) => state.main.salesYears
  );
  const searchOption = useAppSelector((state) => state.main.searchTotalOption);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (searchOption) {
      setSearchString(searchOption.keyword);
      setSort(searchOption.sort as Sort);
      setOrder(searchOption.order as Order);
      setFilterStage(searchOption.stages);
      setSelectMonth(searchOption.selectMonth);
      setIsShowFree(searchOption.isShowFree);
    }
    dispatch(setMenuIndex(isTotal ? 3 : 2));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("setSearchTotalStatus", filterStage, isShowFree, selectMonth);

    dispatch(
      setSearchTotalStatus({
        keyword: searchString,
        sort,
        order,
        stages: filterStage,
        isShowFree,
        selectMonth,
      })
    );
  }, [
    searchString,
    sort,
    order,
    filterStage,
    isShowFree,
    selectMonth,
    dispatch,
  ]);

  const handleOrderBy = (schoolSales: SchoolSales[]) => {
    if (sort === "contract_date") {
      if (order === "asc") {
        schoolSales.sort((a, b) => {
          return a.contractDate > b.contractDate ? 1 : -1;
        });
      } else {
        schoolSales.sort((a, b) => {
          return a.contractDate < b.contractDate ? 1 : -1;
        });
      }
    } else if (sort === "class_date") {
      if (order === "asc") {
        schoolSales.sort((a, b) => {
          return a.classDateFrom < b.classDateFrom ? 1 : -1;
        });
      } else {
        schoolSales.sort((a, b) => {
          return a.classDateFrom > b.classDateFrom ? 1 : -1;
        });
      }
    } else if (sort === "name") {
      if (order === "asc") {
        schoolSales.sort((a, b) => {
          return a.school.name > b.school.name ? 1 : -1;
        });
      } else {
        schoolSales.sort((a, b) => {
          return a.school.name < b.school.name ? 1 : -1;
        });
      }
    } else if (sort === "region") {
      if (order === "asc") {
        schoolSales.sort((a, b) => {
          return a.school.sido.name + a.school.gugun.name + a.school.name >
            b.school.sido.name + b.school.gugun.name + b.school.name
            ? 1
            : -1;
        });
      } else {
        schoolSales.sort((a, b) => {
          return a.school.sido.name + a.school.gugun.name + a.school.name <
            b.school.sido.name + b.school.gugun.name + b.school.name
            ? 1
            : -1;
        });
      }
    } else if (sort === "stage") {
      if (order === "asc") {
        schoolSales.sort((a, b) => {
          return a.stage > b.stage ? 1 : -1;
        });
      } else {
        schoolSales.sort((a, b) => {
          return a.stage < b.stage ? 1 : -1;
        });
      }
    }

    const _schoolSales = schoolSales.filter(
      (s) =>
        salesYears.includes(getYear(s.classDateFrom)) &&
        (isShowFree || !s.isFree)
    );

    if (selectMonth === 0) {
      setFilteredSchoolSalesList(_schoolSales);
      return;
    }

    const _monthSchoolSales = _schoolSales.filter((s) => {
      return getMonth(s.classDateFrom) === selectMonth;
    });

    setFilteredSchoolSalesList(_monthSchoolSales);
  };

  const handleSearch = (
    schoolSales: SchoolSales[],
    str: string,
    filters: number[]
  ): SchoolSales[] => {
    if (str === "" && filters.length === DisplayStages.length) {
      return [...schoolSales];
    }

    const filteredSales = schoolSales.filter((s) => {
      return (
        s.school.name.includes(str) ||
        s.school.sido.name.includes(str) ||
        s.school.gugun.name.includes(str) ||
        s.school.address.includes(str) ||
        s.school.phone.includes(str) ||
        s.teacherName.includes(str) ||
        s.phoneNo.includes(str) ||
        s.email.includes(str) ||
        s.memo.includes(str)
      );
    });

    const stages = filters
      .map((f, i) => {
        return { f, stage: i + 1 };
      })
      .filter((fi) => fi.f)
      .map((fi) => fi.stage);

    return filteredSales.filter((s) => {
      return filterStage.includes(s.stage);
    });
  };

  useEffect(() => {
    const salesList = handleSearch(schoolSalesList, searchString, filterStage);
    handleOrderBy(salesList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    schoolSalesList,
    searchString,
    filterStage,
    sort,
    order,
    salesYears,
    selectMonth,
    isShowFree,
  ]);

  useEffect(() => {
    if (salesYears.length !== 1) {
      setSelectMonth(0);
    }
  }, [salesYears]);

  // useEffect(() => {
  //   const salesList = handleSearch(schoolSalesList, searchString, filterStage);
  //   handleOrderBy(salesList);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [sort, order, searchString, schoolSalesList]);

  const handleCheckFilters = (isChecked: boolean, flag: number) => {
    let filter = [];
    if (isChecked) {
      filter = [...filterStage, flag];
    } else {
      filter = filterStage.filter((f) => f !== flag);
    }

    setFilterStage(filter);
  };

  // const applyFilters = (filter: number[]) => {
  //   setStageFlags(filter);
  // };

  const popupSchoolSales = (e: any, sales: SchoolSales) => {
    if (e.target.closest("a")) {
      return;
    }
    setSelectedSchool(sales.school);
    setSelectedSchoolSales(sales);
    setOpenSales(true);
  };

  // useEffect(() => {
  //   loadSales();
  // }, []);

  const onSaveSchoolSalesCompleted = async (
    schoolSales: SchoolSales,
    isNewMode: boolean
  ) => {
    if (!selectedSchoolSales) {
      console.error("selectedSchoolSales is null", selectedSchoolSales);
      return false;
    }

    setSchoolSalesList(
      schoolSalesList.map((sa) => (sa.id === schoolSales.id ? schoolSales : sa))
    );

    return true;
  };

  const onDeleteSchoolSales = async (
    schoolSales: SchoolSales
  ): Promise<boolean> => {
    if (!selectedSchoolSales) {
      console.error("selectedSchoolSales is null", selectedSchoolSales);
      return false;
    }

    const response = await apiDelete(`/school/sales/${schoolSales.id}`);

    if (response.error) {
      toast.error("삭제 실패");
      console.error("삭제 실패", response.error);
      return false;
    }

    setSchoolSalesList(
      schoolSalesList.filter((sa) => sa.id !== schoolSales.id)
    );

    return true;
  };

  const handleCheckAll = (isChecked: boolean) => {
    setCheckAll(isChecked);
    if (isChecked) {
      setFilterStage(DisplayStages);
    } else {
      setFilterStage([]);
    }
  };

  const handleYearClick = (year: number) => {
    if (salesYears.includes(year)) {
      dispatch(setSalesYears(salesYears.filter((y) => y !== year)));
    } else {
      dispatch(setSalesYears([...salesYears, year]));
    }
  };

  return (
    <PageContainer>
      <SchoolSalesPopup
        open={openSales}
        onOpenChange={(v) => setOpenSales(v)}
        schoolSales={selectedSchoolSales!}
        school={selectedSchool!}
        onClose={() => setOpenSales(false)}
        onSaveCompleted={onSaveSchoolSalesCompleted}
        onDelete={onDeleteSchoolSales}
        isEnableNew={false}
        isShowDelete={true}
        accordionStates={["item-1", "item-2", "item-3"]}
      />
      {/* </Popup> */}
      <PageHeader
        title={isTotal ? "영업현황" : "내 영업"}
        description={
          isTotal
            ? "전체 계약과 수업 진행 상황을 한 화면에서 관리합니다."
            : "내가 등록한 계약과 수업 진행 상황입니다."
        }
      />
      <div className="w-full text-sm text-center">
        <Toolbar>
          <div className="text-sm text-gray-500">정렬</div>
          <Select value={sort} onValueChange={(v) => setSort(v as Sort)}>
            <SelectTrigger className="w-[120px] text-center">
              <SelectValue placeholder="1" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="contract_date">계약일</SelectItem>
                <SelectItem value="class_date">수업일</SelectItem>
                <SelectItem value="name">이름</SelectItem>
                <SelectItem value="region">지역</SelectItem>
                <SelectItem value="stage">단계</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
          <Select value={order} onValueChange={(v) => setOrder(v as Order)}>
            <SelectTrigger className="w-[120px] text-center">
              <SelectValue placeholder="1" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="asc">오름차순</SelectItem>
                <SelectItem value="desc">내림차순</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>

          <div className="pl-2 text-sm">검색</div>
          <Input
            className="w-full sm:w-[200px]"
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
          />

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <div className="flex  items-center gap-1">
              <Checkbox
                id="checkAll"
                className="data-[state=checked]:bg-indigo-600 data-[state=checked]:border-indigo-600"
                checked={checkAll}
                onCheckedChange={(checked: boolean) => handleCheckAll(checked)}
              />

              <Label htmlFor="checkAll">모두선택</Label>
            </div>
            {DisplayStages.map((stage, index) => (
              <div key={index} className="flex  items-center gap-1">
                <Checkbox
                  id={`id${index}`}
                  className="data-[state=checked]:bg-indigo-600 data-[state=checked]:border-indigo-600"
                  checked={filterStage.includes(stage)}
                  onCheckedChange={(checked: boolean) =>
                    handleCheckFilters(checked, stage)
                  }
                />
                <Label htmlFor={`id${index}`}>{StageName[stage]}</Label>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {DisplayYears.map((year) => (
              <div
                key={year}
                className={cn(
                  "text-xs rounded-md py-2 px-3 cursor-pointer",
                  salesYears.includes(year)
                    ? "bg-indigo-600 text-white border border-indigo-600 shadow-sm"
                    : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50"
                )}
                onClick={() => handleYearClick(year)}
              >
                {year}년
              </div>
            ))}
          </div>
        </Toolbar>
        {salesYears.length === 1 && (
          <div className="flex flex-wrap justify-center items-center gap-2 py-4">
            <div
              className={cn(
                "w-12 h-8 rounded-sm border-solid border border-gray-300 cursor-pointer flex items-center justify-center",
                selectMonth === 0
                  ? "bg-indigo-600 text-white border border-indigo-600 shadow-sm"
                  : "text-gray-800 hover:bg-gray-50"
              )}
              onClick={() => setSelectMonth(0)}
            >
              전체
            </div>
            {Array.from({ length: 12 }, (_, i) => (
              <div
                className={cn(
                  "w-8 h-8 rounded-sm border-solid border border-gray-300 cursor-pointer flex items-center justify-center",
                  selectMonth === i + 1
                    ? "bg-indigo-600 text-white border border-indigo-600 shadow-sm"
                    : "text-gray-800 hover:bg-gray-50"
                )}
                onClick={() => setSelectMonth(i + 1)}
              >
                <div>{i + 1}</div>
              </div>
            ))}
            <div className="flex items-center gap-2 pl-2 sm:pl-10">
              <Switch
                checked={isShowFree}
                onCheckedChange={(checked) => setIsShowFree(checked)}
                id="isShowFree"
              />
              <Label htmlFor="isShowFree">무료보기</Label>
            </div>
          </div>
        )}

        <SectionCard className="mt-3 overflow-x-auto">
        <div className="min-w-[1400px]">
        <div className="grid grid-cols-[100px_40px_40px_70px_180px_100px_100px_80px_50px_50px_80px_90px_50px_50px_1fr_1fr] gap-1 items-center px-4 py-2 bg-gray-50 text-gray-500 font-medium border-b border-solid border-gray-200">
          <div className="text-center">단계</div>
          <div className="text-center">번호</div>
          <div className="text-center">SID</div>
          <div className="text-center">영업자</div>
          <div className="text-center">학교이름</div>
          <div className="text-center">계약일시</div>
          <div className="text-center">수업일시</div>

          <div className="text-center">계약수업</div>
          <div className="text-center">교시</div>
          <div className="text-center">계약학급</div>
          <div className="text-center">전체학급</div>
          <div className="text-right">매출</div>

          <div className="text-center">매출입력</div>
          <div className="text-center">계산서</div>
          <div>주소</div>
          <div>메모</div>
          {/* <div>전체학급</div> */}
        </div>
        <div className="border-solid">
          {filteredSchoolSalesList.map((s: SchoolSales, index) => (
            <div
              key={s.id}
              onClick={(e) => popupSchoolSales(e, s)}
              className="grid grid-cols-[100px_40px_40px_70px_180px_100px_100px_80px_50px_50px_80px_90px_50px_50px_1fr_1fr] gap-1 items-center px-4 py-2 border-b border-solid border-gray-200 hover:bg-gray-50  cursor-pointer"
            >
              <Stage stage={s.stage} isFree={s.isFree} />
              <div>{index + 1}</div>
              <div>{s.id}</div>
              <div className="text-center">{s.user.name}</div>
              <div className="flex items-center gap-2">
                <SchoolIcon schoolType={s.school.schoolType} />
                <Link
                  to={s.school.homepage}
                  target="_blank"
                  className="text-indigo-600 underline"
                >
                  {s.school.name}{" "}
                </Link>
              </div>
              <div className="text-center">
                {s.contractDate ? formatKoreanDate(s.contractDate) : ""}
              </div>
              <div className="text-center">
                {s.classDateFrom ? formatKoreanDate(s.classDateFrom) : ""}
              </div>
              <div className="text-center">{ClassNames[s.classType - 1]}</div>
              <div className="text-center">{s.classTimes}</div>
              <div className="text-center">{s.contractCnt}</div>
              <div className="text-center">
                {s.school.grade1ClassCnt +
                  s.school.grade2ClassCnt +
                  s.school.grade3ClassCnt +
                  s.school.grade4ClassCnt +
                  s.school.grade5ClassCnt +
                  s.school.grade6ClassCnt}
              </div>
              <div className="text-right">
                {s.revenue > 0 && s.revenue.toLocaleString()}
              </div>
              <div className="text-center flex justify-center">
                {s.isRevenueInputCompleted &&
                  s.stage >= StageType.CONTRACT_COMPLETED && (
                    <div className="bg-red-400 text-white w-6 h-6 rounded-md text-center">
                      완
                    </div>
                  )}
              </div>
              <div
                className={cn(
                  "text-white w-6 h-6 rounded-md text-center",
                  s.isIssuedSeparate &&
                    !(s.isIssuedLecture && s.isIssuedMaterial)
                    ? "bg-yellow-500"
                    : (s.isIssuedSeparate &&
                        s.isIssuedLecture &&
                        s.isIssuedMaterial) ||
                      (!s.isIssuedSeparate &&
                        (s.isIssuedLecture || s.isIssuedMaterial))
                    ? "bg-green-500"
                    : ""
                )}
              >
                완
              </div>{" "}
              <div>{s.school.address}</div>
              {s.memo.length > 0 && (
                <div>
                  <DescriptionOutlined /> {s.memo}
                </div>
              )}
            </div>
          ))}
        </div>
        </div>
        </SectionCard>
        <div className="pb-10">
          <div className="flex flex-wrap items-center gap-x-10 gap-y-2 rounded-xl border border-gray-200 bg-gray-50/70 mt-3 px-4 py-3 text-left">
            <div className="flex items-center gap-2">
              <div>총계약:</div>
              <div>{filteredSchoolSalesList.length}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-500">총학급수:</div>
              <div>
                {filteredSchoolSalesList
                  .reduce((acc, cur) => acc + cur.contractCnt, 0)
                  .toLocaleString()}
                학급
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-500">총매출:</div>
              <div>
                {filteredSchoolSalesList
                  .reduce((acc, cur) => acc + cur.revenue, 0)
                  .toLocaleString()}
                원
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-500">총수익:</div>
              <div>
                {filteredSchoolSalesList
                  .reduce((acc, cur) => acc + cur.profit, 0)
                  .toLocaleString()}
                원
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-500">총비용:</div>
              <div>
                {filteredSchoolSalesList
                  .reduce((acc, cur) => acc + cur.cost, 0)
                  .toLocaleString()}
                원
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-500">매출 미입력:</div>
              <div>
                {filteredSchoolSalesList.length -
                  filteredSchoolSalesList.filter(
                    (s) => s.isRevenueInputCompleted
                  ).length}
                건
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default SchoolSalesListView;
